import { render, staticRenderFns } from "./FormControlTypeInternalLink.vue?vue&type=template&id=7a672d2e&scoped=true"
import script from "./FormControlTypeInternalLink.vue?vue&type=script&lang=js"
export * from "./FormControlTypeInternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a672d2e",
  null
  
)

export default component.exports